module.exports = __webpack_public_path__ + "img/tn-timeline-main-15.727427f7.jpg";